'use client';

import { useCurrentRefinements, useRefinementList } from 'react-instantsearch';

import { FILTERS } from '@libs/algolia';

import { OPTEX_SHIP_TO_ME_ATTRIBUTE, type OptexDeliveryMethod } from './optexDeliveryFilterConstants';

/**
 * Derives the active Optex delivery radio from InstantSearch refinements.
 * Priority: SDD > pickup/BOPIS > Ship to me.
 */
export function useOptexSelectedDeliveryMethod(): OptexDeliveryMethod | null {
    const sddRefinements = useRefinementList({
        attribute: FILTERS.SCHEDULED_DELIVERY_ELIGIBLE.ATTRIBUTE,
    });

    const { items: deliveryRefinements } = useCurrentRefinements({
        includedAttributes: [
            FILTERS.SHOP_BY_STORE.ATTRIBUTE,
            FILTERS.BOPIS_ELIGIBLE.ATTRIBUTE,
            FILTERS.SCHEDULED_DELIVERY_ELIGIBLE.ATTRIBUTE,
            OPTEX_SHIP_TO_ME_ATTRIBUTE,
        ],
    });

    const hasPickupRefinement = deliveryRefinements.some(item => item.attribute === FILTERS.SHOP_BY_STORE.ATTRIBUTE);
    const hasBopisRefinement = deliveryRefinements.some(item => item.attribute === FILTERS.BOPIS_ELIGIBLE.ATTRIBUTE);
    const hasSddRefinement = sddRefinements.items.some(item => item.value === 'true' && item.isRefined);
    const hasOptexShipToMeRefinement = deliveryRefinements.some(item => item.attribute === OPTEX_SHIP_TO_ME_ATTRIBUTE);

    if (hasSddRefinement) {
        return 'sdd';
    }

    if (hasPickupRefinement || hasBopisRefinement) {
        return 'pickup';
    }

    if (hasOptexShipToMeRefinement) {
        return 'sth';
    }

    return null;
}
